"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Intent = void 0;

/**
 * Master list of intent available in web and iOS
 *
 * Intended action by a user that triggered an event
 * @packageDocumentation
 */
var Intent;
/**
 * Limited Intent available for web authentication events
 *
 * An action taken that prompted the user to view an authentication form
 */

exports.Intent = Intent;

(function (Intent) {
  Intent["bid"] = "bid";
  Intent["buyNow"] = "buyNow";
  Intent["consign"] = "consign";
  Intent["createAlert"] = "createAlert";
  Intent["followArtist"] = "followArtist";
  Intent["followPartner"] = "followPartner";
  Intent["followGene"] = "followGene";
  Intent["forgot"] = "forgot";
  Intent["inquire"] = "inquire";
  Intent["login"] = "login";
  Intent["seeEstimateAuctionRecords"] = "seeEstimateAuctionRecords";
  Intent["seePriceAuctionRecords"] = "seePriceAuctionRecords";
  Intent["seeRealizedPriceAuctionRecords"] = "seeRealizedPriceAuctionRecords";
  Intent["makeOffer"] = "makeOffer";
  Intent["registerToBid"] = "registerToBid";
  Intent["requestConditionReport"] = "requestConditionReport";
  Intent["saveArtwork"] = "saveArtwork";
  Intent["signup"] = "signup";
  Intent["viewAuctionResults"] = "viewAuctionResults";
  Intent["viewArtist"] = "viewArtist";
  Intent["viewEditorial"] = "viewEditorial";
  Intent["viewFair"] = "viewFair";
  Intent["viewViewingRoom"] = "viewViewingRoom";
})(Intent || (exports.Intent = Intent = {}));